import React from "react";

export const PlayStore = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="140"
      height="41"
      viewBox="0 0 140 41"
      fill="none"
    >
      <path
        d="M134.629 40.4444H5.17806C2.33142 40.4444 0 38.1682 0 35.3889V5.05556C0 2.27626 2.33142 -8.2865e-08 5.17806 -8.2865e-08H134.629C137.476 -8.2865e-08 139.808 2.27626 139.808 5.05556V35.3889C139.808 38.1682 137.476 40.4444 134.629 40.4444Z"
        fill="black"
      />
      <path
        d="M134.629 0.810152C137.027 0.810152 138.978 2.71483 138.978 5.05556V35.3889C138.978 37.7296 137.027 39.6343 134.629 39.6343H5.17806C2.78062 39.6343 0.829783 37.7296 0.829783 35.3889V5.05556C0.829783 2.71483 2.78062 0.810152 5.17806 0.810152H134.629ZM134.629 -8.2865e-08H5.17806C2.33142 -8.2865e-08 0 2.27626 0 5.05556V35.3889C0 38.1682 2.33142 40.4444 5.17806 40.4444H134.629C137.476 40.4444 139.808 38.1682 139.808 35.3889V5.05556C139.808 2.27626 137.476 -8.2865e-08 134.629 -8.2865e-08Z"
        fill="#A6A6A6"
      />
      <path
        d="M49.1061 10.3576C49.1061 11.2018 48.8472 11.878 48.3371 12.3823C47.7507 12.9801 46.9869 13.2809 46.051 13.2809C45.1565 13.2809 44.3927 12.9751 43.7662 12.3722C43.1383 11.7605 42.8251 11.0097 42.8251 10.1111C42.8251 9.21248 43.1383 8.46173 43.7662 7.85506C44.3927 7.24713 45.1565 6.94127 46.051 6.94127C46.4963 6.94127 46.9209 7.03101 47.3261 7.19784C47.73 7.36594 48.0588 7.59344 48.297 7.87402L47.7559 8.40738C47.3403 7.92837 46.7746 7.69202 46.051 7.69202C45.3986 7.69202 44.8329 7.91446 44.3526 8.36314C43.8775 8.81309 43.6393 9.39574 43.6393 10.1111C43.6393 10.8265 43.8775 11.4142 44.3526 11.8641C44.8329 12.3077 45.3986 12.5352 46.051 12.5352C46.7436 12.5352 47.3261 12.3077 47.7857 11.8591C48.0886 11.562 48.2607 11.1525 48.306 10.6293H46.051V9.89877H49.0595C49.0957 10.0568 49.1061 10.2097 49.1061 10.3576Z"
        fill="white"
        stroke="white"
        stroke-width="0.16"
        stroke-miterlimit="10"
      />
      <path
        d="M53.879 7.82472H51.0531V9.74583H53.6007V10.4764H51.0531V12.3975H53.879V13.1419H50.2531V7.08029H53.879V7.82472Z"
        fill="white"
        stroke="white"
        stroke-width="0.16"
        stroke-miterlimit="10"
      />
      <path
        d="M57.2473 13.1419H56.4473V7.82472H54.7139V7.08029H58.9819V7.82472H57.2473V13.1419Z"
        fill="white"
        stroke="white"
        stroke-width="0.16"
        stroke-miterlimit="10"
      />
      <path
        d="M62.0707 13.1419V7.08029H62.8694V13.1419H62.0707Z"
        fill="white"
        stroke="white"
        stroke-width="0.16"
        stroke-miterlimit="10"
      />
      <path
        d="M66.4099 13.1419H65.6163V7.82472H63.8765V7.08029H68.1497V7.82472H66.4099V13.1419Z"
        fill="white"
        stroke="white"
        stroke-width="0.16"
        stroke-miterlimit="10"
      />
      <path
        d="M76.2301 12.3621C75.6178 12.9751 74.8592 13.2809 73.9544 13.2809C73.0443 13.2809 72.2857 12.9751 71.6734 12.3621C71.0624 11.7504 70.7582 10.9996 70.7582 10.1111C70.7582 9.22259 71.0624 8.47184 71.6734 7.86012C72.2857 7.24713 73.0443 6.94127 73.9544 6.94127C74.8541 6.94127 75.6126 7.24713 76.225 7.86517C76.8411 8.48195 77.1453 9.22764 77.1453 10.1111C77.1453 10.9996 76.8411 11.7504 76.2301 12.3621ZM72.265 11.854C72.7259 12.3077 73.2864 12.5352 73.9544 12.5352C74.6172 12.5352 75.1829 12.3077 75.6385 11.854C76.0981 11.4003 76.3311 10.8176 76.3311 10.1111C76.3311 9.40459 76.0981 8.82194 75.6385 8.3682C75.1829 7.91446 74.6172 7.68696 73.9544 7.68696C73.2864 7.68696 72.7259 7.91446 72.265 8.3682C71.8055 8.82194 71.5725 9.40459 71.5725 10.1111C71.5725 10.8176 71.8055 11.4003 72.265 11.854Z"
        fill="white"
        stroke="white"
        stroke-width="0.16"
        stroke-miterlimit="10"
      />
      <path
        d="M78.2677 13.1419V7.08029H79.2386L82.2574 11.7946H82.2923L82.2574 10.6293V7.08029H83.0561V13.1419H82.2224L79.0612 8.19504H79.0263L79.0612 9.3654V13.1419H78.2677Z"
        fill="white"
        stroke="white"
        stroke-width="0.16"
        stroke-miterlimit="10"
      />
      <path
        d="M70.5614 21.9942C68.129 21.9942 66.1419 23.8016 66.1419 26.2952C66.1419 28.7687 68.129 30.595 70.5614 30.595C72.9989 30.595 74.986 28.7687 74.986 26.2952C74.986 23.8016 72.9989 21.9942 70.5614 21.9942ZM70.5614 28.9014C69.2267 28.9014 68.0785 27.8258 68.0785 26.2952C68.0785 24.7444 69.2267 23.6878 70.5614 23.6878C71.896 23.6878 73.0494 24.7444 73.0494 26.2952C73.0494 27.8258 71.896 28.9014 70.5614 28.9014ZM60.9185 21.9942C58.481 21.9942 56.4991 23.8016 56.4991 26.2952C56.4991 28.7687 58.481 30.595 60.9185 30.595C63.3548 30.595 65.338 28.7687 65.338 26.2952C65.338 23.8016 63.3548 21.9942 60.9185 21.9942ZM60.9185 28.9014C59.5826 28.9014 58.4305 27.8258 58.4305 26.2952C58.4305 24.7444 59.5826 23.6878 60.9185 23.6878C62.2532 23.6878 63.4014 24.7444 63.4014 26.2952C63.4014 27.8258 62.2532 28.9014 60.9185 28.9014ZM49.444 23.3125V25.14H53.9139C53.7832 26.1613 53.4337 26.912 52.8977 27.4353C52.2453 28.0672 51.2291 28.7687 49.444 28.7687C46.6931 28.7687 44.5391 26.6011 44.5391 23.9153C44.5391 21.2296 46.6931 19.062 49.444 19.062C50.9314 19.062 52.0136 19.6295 52.8123 20.3651L54.1314 19.0772C53.0142 18.0357 51.5281 17.2357 49.444 17.2357C45.6718 17.2357 42.5015 20.2324 42.5015 23.9153C42.5015 27.5983 45.6718 30.595 49.444 30.595C51.4828 30.595 53.0142 29.9428 54.2181 28.7194C55.4518 27.5149 55.8363 25.8213 55.8363 24.4537C55.8363 24.0291 55.8 23.6385 55.7353 23.3125H49.444ZM96.3649 24.7293C96.0012 23.7675 94.8788 21.9942 92.5927 21.9942C90.3273 21.9942 88.4412 23.7371 88.4412 26.2952C88.4412 28.7042 90.3079 30.595 92.8102 30.595C94.8335 30.595 96.0012 29.3905 96.4814 28.689L94.9798 27.7121C94.4788 28.4274 93.7966 28.9014 92.8102 28.9014C91.8302 28.9014 91.1273 28.4628 90.6768 27.5983L96.5682 25.2184L96.3649 24.7293ZM90.3584 26.1613C90.3079 24.503 91.6775 23.6537 92.6587 23.6537C93.4277 23.6537 94.0801 24.0291 94.2976 24.5662L90.3584 26.1613ZM85.57 30.3334H87.5066V17.6945H85.57V30.3334ZM82.3984 22.9522H82.3337C81.8987 22.4492 81.069 21.9942 80.0178 21.9942C77.812 21.9942 75.7951 23.885 75.7951 26.3091C75.7951 28.7194 77.812 30.595 80.0178 30.595C81.069 30.595 81.8987 30.1362 82.3337 29.618H82.3984V30.2348C82.3984 31.8791 81.4987 32.7626 80.0476 32.7626C78.8644 32.7626 78.1304 31.9284 77.8275 31.2269L76.1433 31.9132C76.6288 33.0532 77.9142 34.4562 80.0476 34.4562C82.3182 34.4562 84.234 33.1518 84.234 29.9782V22.2558H82.3984V22.9522ZM80.1835 28.9014C78.8489 28.9014 77.7317 27.8106 77.7317 26.3091C77.7317 24.7937 78.8489 23.6878 80.1835 23.6878C81.4987 23.6878 82.5356 24.7937 82.5356 26.3091C82.5356 27.8106 81.4987 28.9014 80.1835 28.9014ZM105.432 17.6945H100.8V30.3334H102.731V25.5445H105.432C107.577 25.5445 109.68 24.0291 109.68 21.6188C109.68 19.2099 107.572 17.6945 105.432 17.6945ZM105.482 23.7864H102.731V19.4525H105.482C106.924 19.4525 107.748 20.6216 107.748 21.6188C107.748 22.5971 106.924 23.7864 105.482 23.7864ZM117.421 21.9702C116.026 21.9702 114.575 22.5718 113.978 23.9052L115.692 24.6067C116.061 23.9052 116.739 23.6777 117.456 23.6777C118.458 23.6777 119.475 24.2654 119.49 25.3031V25.4358C119.141 25.2386 118.392 24.9467 117.472 24.9467C115.626 24.9467 113.745 25.9388 113.745 27.7904C113.745 29.484 115.257 30.5748 116.957 30.5748C118.256 30.5748 118.974 30.0022 119.424 29.3361H119.49V30.3131H121.356V25.4649C121.356 23.224 119.642 21.9702 117.421 21.9702ZM117.188 28.8963C116.557 28.8963 115.676 28.5905 115.676 27.8258C115.676 26.8476 116.774 26.4722 117.724 26.4722C118.575 26.4722 118.974 26.6554 119.49 26.8968C119.339 28.0672 118.307 28.8963 117.188 28.8963ZM128.152 22.247L125.932 27.726H125.866L123.57 22.247H121.488L124.936 29.9036L122.968 34.1642H124.987L130.301 22.247H128.152ZM110.742 30.3334H112.678V17.6945H110.742V30.3334Z"
        fill="white"
      />
      <path
        d="M10.8065 7.62249C10.5023 7.93341 10.3263 8.41748 10.3263 9.04437V31.4051C10.3263 32.032 10.5023 32.5161 10.8065 32.827L10.8816 32.8952L23.7154 20.3701V20.0743L10.8816 7.54919L10.8065 7.62249Z"
        fill="url(#paint0_linear_1595_7910)"
      />
      <path
        d="M27.9888 24.5472L23.7156 20.3701V20.0743L27.9939 15.8972L28.0897 15.9515L33.1565 18.7662C34.6024 19.565 34.6024 20.8794 33.1565 21.6833L28.0897 24.4929L27.9888 24.5472Z"
        fill="url(#paint1_linear_1595_7910)"
      />
      <path
        d="M28.0897 24.4929L23.7156 20.2222L10.8067 32.827C11.2869 33.3199 12.0701 33.3793 12.9607 32.8864L28.0897 24.4929Z"
        fill="url(#paint2_linear_1595_7910)"
      />
      <path
        d="M28.0897 15.9515L12.9607 7.55805C12.0701 7.07019 11.2869 7.12959 10.8067 7.62251L23.7156 20.2222L28.0897 15.9515Z"
        fill="url(#paint3_linear_1595_7910)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1595_7910"
          x1="22.5759"
          y1="31.638"
          x2="5.61193"
          y2="14.2629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00A0FF" />
          <stop offset="0.0066" stop-color="#00A1FF" />
          <stop offset="0.2601" stop-color="#00BEFF" />
          <stop offset="0.5122" stop-color="#00D2FF" />
          <stop offset="0.7604" stop-color="#00DFFF" />
          <stop offset="1" stop-color="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1595_7910"
          x1="35.0394"
          y1="20.2208"
          x2="9.98078"
          y2="20.2208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE000" />
          <stop offset="0.4087" stop-color="#FFBD00" />
          <stop offset="0.7754" stop-color="#FFA500" />
          <stop offset="1" stop-color="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1595_7910"
          x1="25.7112"
          y1="17.9006"
          x2="2.70662"
          y2="-5.6614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF3A44" />
          <stop offset="1" stop-color="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1595_7910"
          x1="7.55723"
          y1="40.2663"
          x2="17.8298"
          y2="29.7449"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#32A071" />
          <stop offset="0.0685" stop-color="#2DA771" />
          <stop offset="0.4762" stop-color="#15CF74" />
          <stop offset="0.8009" stop-color="#06E775" />
          <stop offset="1" stop-color="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};
